module.exports = __webpack_public_path__ + "static/img/31.212bfc9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/31.png
// module id = uHh5
// module chunks = 1